import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { push } from 'react-router-redux';
import some from 'lodash/some';
import isEmpty from 'lodash/isEmpty';
import { RadioButton, TextInput } from 'sure-components';
import Button from 'shared/lib/components/Button';
import IconCircle from 'shared/lib/components/IconCircle';
import { saveBankAccount, submitClaim } from '../../store/actions';
import * as analytics from 'shared/lib/analytics';
import checkGif from './check.gif';
import './ClaimsBanking.css';


class ClaimsBanking extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isNextButtonEnabled: false,
      accountType: null,
    };
  }

  componentDidMount() {
    document.title = `Claims | Bank Information - Sure`;
    analytics.page('Portal - Claim Bank Information', {
      category: 'claim',
    });
  }

  handleFormChange() {
    // Validate all fields filled
    const isAllFilled = !some([
      this.state.accountType,
      this.inputAccountHolder.value,
      this.inputRoutingNumber.value,
      this.inputAccountNumber.value,
      this.inputConfirmAccountNumber.value,
    ], isEmpty);

    // Validate account number match
    const isAccountNumberMatching = (this.inputAccountNumber.value === this.inputConfirmAccountNumber.value);

    this.setState({
      isNextButtonEnabled: (isAllFilled && isAccountNumberMatching),
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    analytics.track('Portal - Claim Bank Information Next Clicked', {
      category: 'claim',
    });

    const accountDetails = {
      bank_routing_number: this.inputRoutingNumber.value,
      bank_account_number: this.inputAccountNumber.value,
      name_on_account: this.inputAccountHolder.value,
      is_savings: (this.state.accountType === 'savings'),
    };

    const { policyNumber, verticalCode } = this.props.params;

    this.props
      .saveBankAccount(accountDetails)
      .then((bankAccountData) => {
        return this.props.submitClaim({
          bankAccountId: bankAccountData.public_id,
          policyNumber,
          verticalCode,
        });
      })
      .then((response) => {
        this.props.navTo(`/account/claims/${response.claim_id}`);
      });
  }

  handleSelectAccountType(accountType) {
    analytics.track('Portal - Claim Bank Account Type Selected', {
      category: 'claim',
      label: accountType,
    });
    this.setState({
      accountType,
    });
  }

  render() {
    return (
      <div className="ClaimsBanking">
        <div className="Container Container--small">
          <h1 className="ClaimsBanking-heading">
            Please supply us with your bank information for a direct deposit reimbursement.
          </h1>
          <form
            onChange={this.handleFormChange.bind(this)}
            onSubmit={this.handleSubmit.bind(this)}>
            <RadioButton
              name="accountType"
              value="checking"
              title="Checking account"
              disabled={this.props.isInProgress}
              checked={this.state.accountType === 'checking'}
              onChange={this.handleSelectAccountType.bind(this, 'checking')} />
            <RadioButton
              name="accountType"
              value="savings"
              title="Savings account"
              disabled={this.props.isInProgress}
              checked={this.state.accountType === 'savings'}
              onChange={this.handleSelectAccountType.bind(this, 'savings')} />
            <label className="ClaimsBanking-label">
              Name of Account Holder
            </label>
            <TextInput
              name="accountHolder"
              required
              placeholder="Name"
              disabled={this.props.isInProgress}
              ref={(c) => this.inputAccountHolder = c}
            />
            <label className="ClaimsBanking-label">
              9-Digit Routing Number
              <div className="ClaimsBanking-label-help">
                What's this?
                <div className="ClaimsBanking-label-help-tooltip">
                  <img
                    className="ClaimsBanking-label-help-tooltip-image"
                    src={checkGif}
                    alt="Routing and account number on check"
                  />
                </div>
              </div>
            </label>
            <TextInput
              name="routingNumber"
              required
              placeholder="XXXXXXXXX"
              disabled={this.props.isInProgress}
              ref={(c) => this.inputRoutingNumber = c}
            />
            <label className="ClaimsBanking-label">
              Account Number
              <div className="ClaimsBanking-label-help">
                What's this?
                <div className="ClaimsBanking-label-help-tooltip">
                  <img
                    className="ClaimsBanking-label-help-tooltip-image"
                    src={checkGif}
                    alt="Routing and account number on check"
                  />
                </div>
              </div>
            </label>
            <TextInput
              name="accountNumber"
              required
              placeholder="XXXXXXXXXXXX"
              disabled={this.props.isInProgress}
              ref={(c) => this.inputAccountNumber = c}
            />
            <label className="ClaimsBanking-label">
              Confirm Account Number
            </label>
            <TextInput
              name="confirmAccountNumber"
              required
              placeholder="XXXXXXXXXXXX"
              disabled={this.props.isInProgress}
              ref={(c) => this.inputConfirmAccountNumber = c}
            />
            <Button
              disabled={!this.state.isNextButtonEnabled || this.props.isInProgress}>
              Next
            </Button>
          </form>
          <IconCircle
            className="ClaimsBanking-securityIcon"
            icon="lock_outline"
            size={40}
            color="medium"
            background="gray"
          />
          <p className="ClaimsBanking-securityNotice">
            All information is transmitted over a secure connection. All transactions are protected with bank-grade security.
          </p>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isInProgress: state.isSavingBankAccount || state.isSubmittingClaim,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    navTo: (route) => dispatch(push(route)),
    saveBankAccount: (accountDetails) => dispatch(saveBankAccount(accountDetails)),
    submitClaim: (details) => dispatch(submitClaim(details)),
  };
};

export default connect(
  mapStateToProps, mapDispatchToProps
)(withRouter(ClaimsBanking));
